<template>
    <div class="bottom_page">
        <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="10"
                :layout="layouts"
                :total="total"
        >
        </el-pagination>
    </div>

</template>

<script>
    export default {
        name: "pagination",
        props:{
            currentPage: {
                type: Number,
            },
            pageSizes:{
                type:Array
            },
            total:{
                type:Number
            },
            changelayouts:{
                type:Boolean
            }
        },
        data(){
          return{
              layouts:'total, prev, pager, next,sizes, jumper'
          }
        },
        created(){
          if(this.changelayouts==true)this.layouts= 'total, prev, pager, next,sizes'
        },
        methods:{
            handleSizeChange(val) {
                //每页
                this.$emit("handleSizeChange",val);
            },
            handleCurrentChange(val) {
                //当前页
                this.$emit("handleCurrentChange",val);
            },
        }
    }
</script>

<style lang="scss">
    .bottom_page{
        .el-pagination{
            text-align: right;
            padding: 20px 0;
        }
    }
</style>
